import * as React from "react";
import { useState } from "react";
import { vinylSizeOptions } from "../../../../types/VinylSizeOptions";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import VinylCombobox from "../VinylCombobox";

const VinylConfigurationSelector = ({
  onVinylConfigurationUpdated,
  vinylColors,
  vinylFonts,
  vinylConfiguration,
  vinylConfigurationInputErrors: {
    names: namesErrors,
    namesColorId: namesColorIdErrors,
    namesFontId: namesFontIdErrors,
    numbers: numbersErrors,
    numbersColorId: numbersColorIdErrors,
    numbersFontId: numbersFontIdErrors,
    size: sizeErrors
  }
}) => {
  // States:
  const [vinylNamesCheckboxChecked, setVinylNamesCheckboxChecked] = useState(
    vinylConfiguration.names
  );
  const [vinylColorSelection, setVinylColorSelection] = useState(
    vinylConfiguration.namesColorId
  );
  const [vinylFontSelection, setVinylFontSelection] = useState(
    vinylConfiguration.namesFontId
  );
  const [vinylNumbersCheckboxChecked, setVinylNumbersCheckboxChecked] =
    useState(vinylConfiguration.numbers);

  // Handlers:
  const handleVinylSizeComboboxSelect = size => {
    onVinylConfigurationUpdated({ size });
  };

  const handleVinylColorSelectorSelect = colorId => {
    setVinylColorSelection(colorId);
    onVinylConfigurationUpdated({
      namesColorId: vinylNamesCheckboxChecked ? colorId : null,
      numbersColorId: vinylNumbersCheckboxChecked ? colorId : null
    });
  };

  const handleVinylFontSelectorSelect = fontId => {
    setVinylFontSelection(fontId);
    onVinylConfigurationUpdated({
      namesFontId: vinylNamesCheckboxChecked ? fontId : null,
      numbersFontId: vinylNumbersCheckboxChecked ? fontId : null
    });
  };

  const handleVinylNamesCheckboxChange = event => {
    const isChecked = event.target.checked;
    setVinylNamesCheckboxChecked(isChecked);
    onVinylConfigurationUpdated({
      names: isChecked,
      namesColorId: isChecked ? vinylColorSelection : null,
      namesFontId: isChecked ? vinylFontSelection : null,
      numbersColorId: vinylNumbersCheckboxChecked ? vinylColorSelection : null,
      numbersFontId: vinylNumbersCheckboxChecked ? vinylFontSelection : null
    });
  };

  const handleVinylNumbersCheckboxChange = event => {
    const isChecked = event.target.checked;
    setVinylNumbersCheckboxChecked(isChecked);
    onVinylConfigurationUpdated({
      numbers: isChecked,
      namesColorId: vinylNamesCheckboxChecked ? vinylColorSelection : null,
      namesFontId: vinylNamesCheckboxChecked ? vinylFontSelection : null,
      numbersColorId: isChecked ? vinylColorSelection : null,
      numbersFontId: isChecked ? vinylFontSelection : null
    });
  };

  return (
    <React.Fragment>
      <div>
        <Typography variant="subtitle2">Vinyl Configuration</Typography>
        <div>
          <FormControlLabel
            error={namesErrors.join(", ")}
            control={
              <Checkbox
                checked={vinylNamesCheckboxChecked}
                onChange={handleVinylNamesCheckboxChange}
                color="primary"
              />
            }
            label="Names"
          />
          <FormControlLabel
            error={numbersErrors.join(", ")}
            control={
              <Checkbox
                checked={vinylNumbersCheckboxChecked}
                onChange={handleVinylNumbersCheckboxChange}
                color="primary"
              />
            }
            label="Numbers"
          />
          {(vinylNamesCheckboxChecked || vinylNumbersCheckboxChecked) && (
            <React.Fragment>
              <VinylCombobox
                label="Vinyl Size"
                options={vinylSizeOptions}
                errorText={[...sizeErrors]}
                onSelect={handleVinylSizeComboboxSelect}
              />
              <VinylCombobox
                label="Vinyl Color"
                options={vinylColors}
                errorText={[...namesColorIdErrors, ...numbersColorIdErrors]}
                onSelect={handleVinylColorSelectorSelect}
              />
              <VinylCombobox
                label="Vinyl Font"
                options={vinylFonts}
                errorText={[...namesFontIdErrors, ...numbersFontIdErrors]}
                onSelect={handleVinylFontSelectorSelect}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default VinylConfigurationSelector;
